module.exports = __webpack_public_path__ + "img/builder-24.3cf066ae.jpg";